export const helperUndo = (
  active: boolean,
  setante: any,
  anteHistory: string[],
  setanteHistory: any,
  clearStakes: any,
  handleDealOut: any,


) => {
  if (active) {
    handleDealOut()
    clearStakes()
    if (anteHistory.length <= 2) {
      setante('0')
      setanteHistory(['0'])
    } else {
      setante(anteHistory[anteHistory.length - 2])
      setanteHistory((h: any) => {
        h.length = h.length - 1
        return [...h]
      })
    }
  }
}
